import { Callable } from '@vimeo/core/types/generic';

/**
 * Stop propagation of DOM event defaults.
 */
export function stopEventPropagationPreventDefault(
  event: Pick<Event, 'stopPropagation' | 'preventDefault'>,
): void {
  event.stopPropagation();
  event.preventDefault();
}

/**
 * Stop propagation of DOM event defaults.
 */
export function stopEventPropagation(event: { stopPropagation: Callable }): void {
  event.stopPropagation();
}
